import React, { useContext, useEffect, useMemo, useRef } from "react";
import PropTypes from "prop-types";
import i18n from "i18next";
import { getTrueClasses } from "../../../helpers";
import { MediaAuthContext } from "../../../store/context/media-auth-context";
import { LayoutContext } from "../../../store/context/layout-context";
import { FooterContext } from "../../../store/context/footer-context";
import EN from "../../../locales/en/header-footer.json";
import DE from "../../../locales/de/header-footer.json";
import CN from "../../../locales/cn/header-footer.json";
import JA from "../../../locales/ja/header-footer.json";
import ES from "../../../locales/es/header-footer.json";
import FR from "../../../locales/fr/header-footer.json";
import updateLinks from "./Navigation/Links/updateLinks";
import Container from "../../common/UI/Container";
import Logos from "./Logos";
import Navigation from "./Navigation";
import Bottom from "./Bottom";
import "./index.scss";
import "./local.scss";

const resources = {
  en: { translation: EN },
  de: { translation: DE },
  cn: { translation: CN },
  ja: { translation: JA },
  es: { translation: ES },
  fr: { translation: FR },
};

const Footer = ({ customClass, isHiddenNavigation, language = "en" }) => {
  const LANGUAGE = useMemo(
    () => (resources[language] ? language : "en"),
    [language]
  );
  const {
    auth: { isAuth },
  } = useContext(MediaAuthContext);

  if (isHiddenNavigation) {
    return null;
  }

  i18n.init({
    lng: LANGUAGE,
    resources,
  });

  const t = i18n.t;

  const navigationData = useMemo(
    () => updateLinks({ language: LANGUAGE, isSavedUser: isAuth }),
    [isAuth, LANGUAGE]
  );
  const footerRef = useRef(null);
  const { setIsShowFooter } = useContext(LayoutContext);

  const checkShow = () =>
    footerRef.current.getBoundingClientRect().top < window.innerHeight;
  const scrollHandler = () => {
    setIsShowFooter(checkShow());
  };

  useEffect(() => {
    window.addEventListener("scroll", scrollHandler);
    window.addEventListener("resize", scrollHandler);
    return () => {
      window.removeEventListener("resize", scrollHandler);
      window.removeEventListener("scroll", scrollHandler);
    };
  }, []);

  return (
    <FooterContext.Provider
      value={{
        navigationData,
        language: LANGUAGE,
        t,
      }}
    >
      <div
        className={getTrueClasses(
          "GCL-F",
          LANGUAGE !== "en" && `GCL-F_${LANGUAGE}`,
          customClass
        )}
        ref={footerRef}
      >
        <Container mode="standard">
          <Logos />
          <Navigation />
          <hr className="GCL-F__delimiter" />
          <Bottom />
        </Container>
      </div>
    </FooterContext.Provider>
  );
};

Footer.propTypes = {
  customClass: PropTypes.string,
  isHiddenNavigation: PropTypes.bool,
  language: PropTypes.string,
};

export default Footer;
